import {useMemo} from 'react';
import {UseFormReturn} from 'react-hook-form';
import {isTaxTypeZero} from 'utils/tax';

import {Deserializer, ModalFormField} from './utils';

const useTaxTypeReadOnly = (form: UseFormReturn<ModalFormField>) => {
    const taxTypeRadio = form.watch('taxTypeRadio');

    return useMemo(
        () =>
            taxTypeRadio === null
                ? false
                : isTaxTypeZero(Deserializer.taxType(taxTypeRadio)),
        [taxTypeRadio],
    );
};

export default useTaxTypeReadOnly;
